import styled from 'styled-components';

const Container = styled.div<{ $isClickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ $isClickable }) => $isClickable ? 'pointer' : 'default'};
  
  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

const Label = styled.span`
  font-size: 13px;
  line-height: 18px;
  font-weight: normal;
`;

const PopOverMenuWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const PopOverMenuContent = styled.div`
  margin-block: 10px;
  margin-inline: 15px;
`;

const PopOverMenuMessage = styled.p`
  font-size: 12px;
  line-height: 21px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.text};
`;

export const Styled = {
  Container,
  Label,
  PopOverMenuWrapper,
  PopOverMenuContent,
  PopOverMenuMessage,
};
